import React from 'react';
import { Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SnackbarContentStyled } from './styles.ts';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { hideSnack } from '../../actions/snackbar.ts';

export default function SnackbarComponent() {
  const dispatch = useDispatch();
  const isShowSnackbar = useSelector(state => state.core.isShowSnackbar);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={isShowSnackbar.show}
      onClose={() => dispatch(hideSnack())}
      autoHideDuration={isShowSnackbar.autoHideDuration}
    >
      <SnackbarContentStyled
        customVariant={isShowSnackbar.variant}
        message={
          isShowSnackbar.intlId ? (
            <FormattedMessage
              id={isShowSnackbar.intlId}
              defaultMessage={isShowSnackbar.defaultMessage}
            />
          ) : (
            isShowSnackbar.message
          )
        }
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={() => dispatch(hideSnack())}
          >
            <CloseIcon />
          </IconButton>
        }
      />
    </Snackbar>
  );
}
